import List from '@material-ui/core/List'
import styled from 'styled-components'

export const appMenuStyles = {
  List: styled(List)`
    width: 100%;
  `
}
